import { Observable } from "rxjs";
import { FeatureFlagEnum } from "../enum/featureFlag.enum";
import { Auth } from "../../models/auth.model";

export abstract class FeatureFlagPort {
  abstract configFeatureFlag( authData: Auth | any ):  Observable<void>
  abstract getFeatureFlag( id: FeatureFlagEnum): Observable<boolean>
}
